import { useTranslation } from "@coworker/locales";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./Priority.module.css";
import FixaStatus from "@coworker/apprestructured/src/shared/wrappers/FixaStatus/FixaStatus";

function Priority() {
  const { t } = useTranslation();

  return (
    <FixaStatus
      label={
        <FixaText textStyle="Heading.XS" className={styles["label"]}>
          {t("priorityString")}
        </FixaText>
      }
      statusColor="red"
      small
    />
  );
}

export default Priority;
